import { useContext, useState } from "react"
import { myAxios } from "../utils/fetch"
import { UserGlobalContextMemorySpace } from "../contexts/user/userGlobalContext"

export const useCredential = (dni) => {
    const { user } = useContext(UserGlobalContextMemorySpace)
    const [loadCredential, setLoadCredential] = useState(false)
    const [credencial, setCredential] = useState({ FechaIngreso: '', IvaTax: '' })

    const { user: {
        data: {
            Token
        }
    } } = user

    const getCredential = async () => {

        setLoadCredential(true)

        myAxios({
            url: `${process.env.REACT_APP_GATEWAY_QA}/customers/api/v1/getinfocredentialbydni?dni=${dni}`,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Token}`,
                Accept: "application/json",
            },
        })
            .then((response) => {
                setCredential(response.data.data)
                return response.data.data
            })
            .catch((error) => {
                if (!error.response.Data) {
                    setCredential(undefined)
                    return
                }
            })
            .finally(() => {
                setLoadCredential(false)
            })
    }


    return {
        getCredential,
        credencial,
        loadCredential
    }
}